/**
 * CP-61: the Hot PRICE DROP badge claims a drop, so it is shown only when
 * the same card shows a was-price and a save amount for the cabin printed
 * on the current fare. A stale fare (CP-55) hides that price block, and the
 * badge goes with it.
 *
 * Keep in sync with price_drop_badge_visible in backend/app/routes.py.
 */
import { showsListingPrice } from '@/utils/priceFreshness';

function positiveFare(value) {
  if (typeof value === 'boolean' || value == null || value === '') return null;
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : null;
}

function cabinKey(value) {
  if (value == null) return null;
  const key = String(value).trim().toLowerCase().replace(/\s+/g, ' ');
  if (!key || key === 'unknown') return null;
  return key;
}

export function priceDropBadgeVisible(deal) {
  if (!deal || deal.price_drop_badge === false) return false;
  if (!showsListingPrice(deal)) return false;
  const current = positiveFare(deal.current_price);
  const peak = positiveFare(deal.peak_price);
  const save = positiveFare(deal.price_drop);
  if (current == null || peak == null || save == null) return false;
  if (peak <= current) return false;
  if (Math.abs((peak - current) - save) >= 0.02) return false;
  const currentCabin = cabinKey(deal.current_cabin_type);
  const peakCabin = cabinKey(deal.peak_cabin_type);
  if (!currentCabin || currentCabin !== peakCabin) return false;
  return true;
}

/** Biggest Price Drops membership. Same rule as the PRICE DROP badge. */
export function realPriceDropDeals(deals) {
  if (!Array.isArray(deals)) return [];
  return deals.filter((deal) => priceDropBadgeVisible(deal));
}
